import NativeSelect from "@material-ui/core/NativeSelect";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import React from "react";
import styled from "styled-components";

import { color } from "style/constants";

export const StyledSelect = styled(({ width, ...otherProps }) => <NativeSelect {...otherProps} />)`
  && {
    padding-left: 0px;
    padding-right: 5px;
    padding-bottom: 0px;
    ${props => props.width && `width: ${props.width};`}

    select {
      padding: 1rem 2rem 1rem 1rem;
    }
    &:before {
      border-bottom-width: 0px !important;
    }
    &:after {
      border-bottom-width: 0px !important;
    }
  }
`;

export const CheckIcon = styled(CheckCircleOutlineIcon)`
  && {
    fill: ${color.GREEN};
  }
`;

export const ErrorIcon = styled(ErrorOutlineIcon)`
  && {
    fill: ${color.RED};
  }
`;
